import { RecordViewList } from "web/components"

import Tile from "../../Tile/Tile"
import { NavigationProvider } from "web/contexts"

export default function RelatedEntitiesTile({
  tileId,
  title,
  data,
  fields,
  handleTileSettings,
  handleOnHide,
  subjectType,
  breakoutLink,
  emptyMessage,
  isTemplate,
  canEdit = true,
  isDoubleColumn,
}) {
  function goToRelatedEntity() {
    if (breakoutLink) {
      window.Turbo.visit(breakoutLink)
    }
  }

  return (
    <Tile
      canEdit={canEdit}
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={tileId}
      title={title}
      breakoutLink={!isTemplate && breakoutLink}
    >
      <NavigationProvider subjectType={subjectType}>
        <RecordViewList
          data={data}
          fields={fields}
          fieldActions={{ name: goToRelatedEntity }}
          emptyMessage={emptyMessage}
          showDummyData={isTemplate}
          isDoubleColumn={isDoubleColumn}
        />
      </NavigationProvider>
    </Tile>
  )
}
